import styled from 'styled-components';
const Wrapper = styled.div`
  .row {
    display: grid;
    grid-template-columns: 8fr 4fr;
  }
  .m-30 {
    margin: 20px 0px;
  }
  .form-check-input:checked {
    background-color: #05ae4b !important;
  }
  .text-white {
    color: white;
  }
`;

export default Wrapper;
